<template>
  <layout-content>
    <payments-methods v-if="$config.available_payment_methods.length > 0" />
    <table-component />
  </layout-content>
</template>
<script>
  import PaymentsMethods from '@core/components/payments/payments-methods';
  import TableComponent from '@core/components/payments/payments-table';

  export default {
    components: { PaymentsMethods, TableComponent }
  };
</script>